<app-modal
  [title]="'Usuń klienta'"
  [confirmLabel]="'Usuń'"
  [showConfirm]="true"
  [showCancel]="true"
  [onConfirmAction]="deleteClient.bind(this)"
>
  <p>
    Na pewno chcesz usunąć klienta
    <b>{{ client?.name }}</b>
    ?
  </p>
  <br />
  <p class="text-red-600">
    <strong>Wszystkie powiązane z nim elementy zostaną usunięte.</strong>
  </p>
</app-modal>
